import { render, staticRenderFns } from "./advisor-page.vue?vue&type=template&id=0ab958d4&"
import script from "./advisor-page.vue?vue&type=script&lang=js&"
export * from "./advisor-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports